export function expect<T>(value: T | null | undefined, errorMessage = 'Unexpected null or undefined'): T {
	if (value === null || value === undefined) {
		throw new Error(errorMessage);
	}

	return value;
}
